module.exports = __webpack_public_path__ + "img/logo-black.7a0dc2ea.png";